import { render, staticRenderFns } from "./boardCut.vue?vue&type=template&id=7191f491&scoped=true&"
import script from "./boardCut.vue?vue&type=script&lang=js&"
export * from "./boardCut.vue?vue&type=script&lang=js&"
import style0 from "./boardCut.vue?vue&type=style&index=0&id=7191f491&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7191f491",
  null
  
)

export default component.exports
import {QHeader,QToolbar,QBtn,QTooltip,QToolbarTitle,QBtnDropdown,QMarkupTable,QCheckbox,QInput,QCard,QCardSection} from 'quasar'
component.options.components = Object.assign({QHeader,QToolbar,QBtn,QTooltip,QToolbarTitle,QBtnDropdown,QMarkupTable,QCheckbox,QInput,QCard,QCardSection}, component.options.components || {})
